import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface MdesMerchantsResultProps {
  data?: Api.SearchResult<MDESMerchantsApi.MdesMerchantSearchResult>;
  searchQuery: string;
}

const MdesMerchant = ({
  mdesMerchant,
  searchQuery,
}: {
  searchQuery: string;
  mdesMerchant: MDESMerchantsApi.MdesMerchantSearchResult;
}) => {
  const openGroup = useCallback(() => {
    history.push(`${ROUTES.MDES_MERCHANTS}?mdesMerchantId=${mdesMerchant.id}`);
  }, [mdesMerchant.id]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={mdesMerchant.mdesMerchantName}
        />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={mdesMerchant.id}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the MdesMerchants catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<Api.MdesMerchantSearchResult>} data - api response
 */

const MdesMerchants = ({ data, searchQuery }: MdesMerchantsResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.MDES_MERCHANTS}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogMdesMerchants")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((u, index) => (
            <MdesMerchant
              key={index}
              searchQuery={searchQuery}
              mdesMerchant={u}
            />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default MdesMerchants;
